export const GET_ALL_FRAME_SHAPES_REQUEST = "GET_ALL_FRAME_SHAPES_REQUEST";
export const GET_ALL_FRAME_SHAPES_SUCCESS = "GET_ALL_FRAME_SHAPES_SUCCESS";
export const GET_ALL_FRAME_SHAPES_FAILURE = "GET_ALL_FRAME_SHAPES_FAILURE";
export const ADD_FRAME_SHAPE_SUCCESS = "ADD_FRAME_SHAPE_SUCCESS";
export const DELETE_FRAME_SHAPE_SUCCESS = "DELETE_FRAME_SHAPE_SUCCESS";
export const UPDATE_FRAME_SHAPE_SUCCESS = "UPDATE_FRAME_SHAPE_SUCCESS";
